export default {
  fields: {
    price: 'Preț',
    tax: 'Taxă',
    visible_to: 'Vizibil pentru',
  },
  buttons: {
    add_price: '+ Adaugă preț',
  },
};
